import React, { useEffect, useRef, useState } from 'react';
import './profile-photo.css'
import { Button, FileUploader } from 'devextreme-react';
import useAxiosPrivate, { axiosHrPrivate } from '../../../../api/useAxios';
import { readFileAndConvert } from '../../../../utils/file-functions';
import notify from 'devextreme/ui/notify';

function ProfilePhoto({ employeeId }) {

  const [image, setImage] = useState(null);
  const [formData, setFormData] = useState()
  const [uploading, setUploading] = useState(false)
  const axiosPrivate = useAxiosPrivate(axiosHrPrivate, "json")
  const btnRef = useRef()


  useEffect(() => {
    if (employeeId) {
      try {
        axiosPrivate.get(`/api/EmployeeProfilePhoto/Employee/${employeeId}`)
          .then((response) => {
            if (response?.status === 200)
              if (response.data?.data)
                setFormData(response.data?.data)
          })
          .catch((error) => console.log(error))
      } catch (error) {
        console.log(error)
      }

    }
  }, [])

  const uploadPhoto = async () => {

    if (image) {

      const tmpFormData = { ...formData }
      tmpFormData.photo = image
      tmpFormData.employeeId = employeeId

      const data = {}
      data.values = JSON.stringify(tmpFormData)

      if (tmpFormData?.id)
        data.key = tmpFormData.id;


      const axiosOptions = {
        method: tmpFormData.id ? "put" : "post",
        url: "/api/EmployeeProfilePhoto/FormData",
        data: data
      }

      try {

        const response = await axiosPrivate(axiosOptions)

        if (response?.status === 201 || response?.status === 200) {
          if (response.data.data)
            setFormData(response.data.data)
          notify("Resim kaydedildi.","success")

        }
      } catch (error) {
        //notify("Bir hata oluştu. Kayıt başarısız.", "danger")
      }

    }
  }


  const onClick = async (e) => {
    uploadPhoto()
  }


  const onValueChanged = (e) => {
    
    setUploading(true)
    const file = e.value[0];

    readFileAndConvert(file)
      .then(base64Data => {
        setImage(base64Data);
      })
      .catch(error => console.log("readFileAndConvert error", error))
      ;

    // const reader = new FileReader();
    // reader.onload = () => {
    //   const base64Data = reader.result;
    //   const url = base64Data;
    //   setImage(url);
    // };
    // reader.readAsDataURL(file);
  }

  useEffect(() => {
    if (image)
      if (uploading) {
        uploadPhoto()
        setUploading(false)
      }
  }, [image])

  return (
    <React.Fragment>

      <div className='photo-border'>
        {/* {image && <img className='photo' src={image} />} */}
        {formData?.photo && <img className='photo' src={formData.photo} />}

      </div>
      <button ref={btnRef} className='photo-button' disabled={!employeeId} >{formData?.photo ? "Resim Güncelle" : "Resim Yükle"}</button>


      <FileUploader
        dialogTrigger={btnRef}
        id='fileupload1'
        selectButtonText="Resim Seç"
        visible={false}
        uploadMode='useForm'
        labelText=""
        accept="image/*"
        showFileList={false}
        onUploaded={(e) => console.log("onUploaded", e)}
        onValueChanged={onValueChanged}
      >

      </FileUploader>

    </React.Fragment>
  );
}



export default ProfilePhoto;